const Links = {
  User: (userId: string) => `/people/${userId}`,
  UserMeetings: (userId: string) => `/people/${userId}/meetings`,
  UserMetrics: (userId: string) => `/people/${userId}/metrics`,
  UserImplementation: (userId: string) => `/people/${userId}/implementation`,
  UserSettings: () => `/settings`,
  UserStrategy: (userId: string) => `/people/${userId}/strategy`,
  UserNotificationSettings: () => `${Links.UserSettings()}#notifications`,
  UserNotifications: () => `/notifications`,
  UserFeedback: (userId: string) => `/people/${userId}/feedback`,
  UserFeedbackDetails: (formSubmissionGuid: string) => `/feedback/${formSubmissionGuid}`,
  Meeting: (meetingGuid: string) => `/meetings/${meetingGuid}`,
  Role: (guid: string) => `/roles/${guid}`,
  Team: (slug: string) => `/teams/${slug}`,
  TeamStrategicMap: (slug: string) => `/teams/${slug}/strategic-map`,
  TeamImplementation: (slug: string) => `/teams/${slug}/implementation`,
  TeamMeetings: (slug: string) => `/teams/${slug}/meetings`,
  TeamMetrics: (slug: string) => `/teams/${slug}/metrics`,
  TeamResources: (slug: string) => `/teams/${slug}/resources`,
  TeamSettings: (slug: string) => `/teams/${slug}/settings`,
  ActionItemDetail: (actionItemGuid: string) => `/strategic-items/${actionItemGuid}`,
  TaskItemDetail: (taskItemGuid: string) => `/task-items/${taskItemGuid}`,
  IssueDetail: (guid: string) => `/loops/${guid}`,
  MetricDetail: (guid: string) => `/metrics/${guid}`,
  RoleDetail: (guid: string) => `/roles/${guid}`,
  Surveys: () => `/surveys`,
  Survey: (guid: string) => `/surveys/${guid}`,
  SurveyResponses: (slug: string) => `/surveys/${slug}/responses`,
  SurveyActions: (slug: string) => `/surveys/${slug}/actions`,
  SurveyResponse: (slug: string) => `/surveys/${slug}/response`,
  Search: (query: string, filter?: string) => {
    const urlSearchParams = new URLSearchParams({ query: query });

    if (filter != null) {
      urlSearchParams.append("filter", filter);
    }

    return `/search?${urlSearchParams.toString()}`;
  },
};

export { Links };
